import { createFileRoute } from "@tanstack/react-router";
import { fotoServiceCityRoute } from "@/lib/seo/fotoServiceCityRoute";

export const Route = createFileRoute("/foto/foretagsfotograf-goteborg")(fotoServiceCityRoute("foretagsfotograf-goteborg"));
